<template>
    <div @wheel="wheel" @click.stop="buttonClose">
        <div class="starter">
          <Video/>
            <div class="container">
                <h1 class="starter__title" v-html="starterScreen.starterTitle"></h1>
                <p class="starter__text"  :class="{ hover: activeHover }" v-html="starterScreen.starterText"></p>
                <router-link class="starter__image" :to="{name: `${langUrl === 'ru' ? 'OneRu' : 'OneEn'}`}">
                    <div :class="{ hover: activeHover }" @mouseover="activeHover = true" @mouseleave="activeHover = false">
                        <img :src="starterScreen.starterImage" alt="">
                    </div>
                </router-link>
            </div>
        </div>
        <div class="footer">
            <div class="container">
                <router-link v-tooltip.right="{content: `${arrowTextDown}`, class: 'tooltip-arrows'}" class="arrow" :to="{name: `${langUrl === 'ru' ? arrowsDownLink + 'Ru' : arrowsDownLink + 'En'}`}">
                    <img src="@/img/Union.png" alt="">
                </router-link>
                   <div class="footer__socicon_block">
                           <MarketButton/>
<!--                     <img class="footer__socicon__img" :src="starterScreen.footerSociconImg" alt="">-->
                     <a :href="socIcon.textUrl" class="footer__socicon" target="_blank" v-for="socIcon in footerSocicon" :key="socIcon.id">
                       <i :class="socIcon.textClass"></i>
                     </a>
                   </div>
                 </div>
        </div>
    </div>
</template>

<script>
import {HTTP, Routes} from '../API';
import MarketButton from "@/components/Buttons/MarketButton";
import Video from "@/components/Video";


export default {
  name: "PageStart",
  components: {Video, MarketButton},
  data: () => ({
    starterScreen: [],
    page: true,
    footerSocicon: [],
    activeHover: false,
    arrowsDown: null,
    arrowTextDown: null,
    sortScreenUp: null,
    sortScreenDown: null,
    arrowsDownLink: null,

  }),
  props: {
    lang: {type: String},
    sortScreen: {type: Array},
    langUrl: {type: String}
  },
  watch: {
    lang(newValue, oldValue){
      this.getContent();
    }
  },
  mounted: function() {
    this.getContent()
  },
  computed: {
    isVisibilityButton() {
      return this.$store.state.button.isCloseButton
    }
  },
  methods: {
    buttonClose(){
        this.$store.dispatch('buttonAction', true)
    },
    getContent() {
      if (this.lang !== undefined && this.lang !== null) {
        HTTP.get(Routes.footer)
            .then(  response => {
              this.footerSocicon = response.data[this.lang].footer.footerSocicon
            })
        HTTP.get(Routes.arrows)
            .then(response => {
              this.arrowsDown = response.data[this.lang].down[0]
              this.arrowTextDown = this.arrowsDown.downText
              this.arrowsDownLink = this.arrowsDown.downTextUrl
            })
      }
    },
    wheel(ev) {
      this.sortScreenUp = this.sortScreen[0].SCROL_UP ? this.sortScreen[0].SCROL_UP : '';
      this.sortScreenDown = this.sortScreen[0].SCROL_DW ? this.sortScreen[0].SCROL_DW : '';

      if (ev.deltaY > 0) {
        setTimeout(() => {
          if (this.$router.history.current.path !== `/${this.langUrl}/${this.sortScreenDown}`) {
            this.$router.push(`/${this.langUrl}/${this.sortScreenDown}`);
          }
        }, 0);
      }
    },
  }
}
</script>